if (!customElements.get('m-product-details-tabs')) {
  class ProductDetailsTabs extends HTMLElement {
    connectedCallback() {
      this.tabHeaders = Array.from(this.querySelectorAll('.m-tab-header'));
      this.accordionHeaders = Array.from(this.querySelectorAll('.m-tab-accordion'));
      this.tabPanels = Array.from(this.querySelectorAll('.m-tab-content'));
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.mobileAccordion = this.dataset.mobileAccordion === 'true';
      this.defaultOpen = this.dataset.defaultOpen === 'true';
      this.activeIndex = 0;
      this.openIndex = this.defaultOpen ? 0 : -1;

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBreakpoint = this.handleBreakpoint.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.mobileQuery.addEventListener('change', this.handleBreakpoint);

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.mobileQuery?.removeEventListener('change', this.handleBreakpoint);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleClick(event) {
      const tab = event.target.closest('.m-tab-header');
      if (tab && this.contains(tab)) {
        this.activeIndex = Number(tab.dataset.index);
        this.renderDesktop(true);
        return;
      }

      const accordion = event.target.closest('.m-tab-accordion');
      if (accordion && this.contains(accordion)) {
        const index = Number(accordion.dataset.index);
        this.openIndex = this.openIndex === index ? -1 : index;
        this.activeIndex = index;
        this.renderMobile();
      }
    }

    handleKeydown(event) {
      const tab = event.target.closest('.m-tab-header');
      if (!tab || !this.contains(tab)) return;

      const currentIndex = Number(tab.dataset.index);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabHeaders.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabHeaders.length) % this.tabHeaders.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabHeaders.length - 1;

      if (nextIndex !== currentIndex) {
        event.preventDefault();
        this.activeIndex = nextIndex;
        this.renderDesktop(true);
      }
    }

    handleBreakpoint() {
      if (this.mobileQuery.matches && this.mobileAccordion && this.openIndex === -1 && this.defaultOpen) {
        this.openIndex = this.activeIndex;
      }
      this.render();
    }

    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const index = Number(event.target.dataset.index);
      if (Number.isNaN(index)) return;

      this.activeIndex = index;
      this.openIndex = index;
      this.render();
    }

    render() {
      if (this.mobileQuery.matches && this.mobileAccordion) {
        this.renderMobile();
      } else {
        this.renderDesktop(false);
      }
    }

    renderDesktop(focusTab) {
      this.tabHeaders.forEach((tab, index) => {
        const isActive = index === this.activeIndex;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.tabPanels.forEach((panel, index) => {
        const isActive = index === this.activeIndex;
        panel.classList.toggle('active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });

      this.accordionHeaders.forEach((header) => header.setAttribute('aria-expanded', 'false'));
      if (focusTab) this.tabHeaders[this.activeIndex]?.focus();
    }

    renderMobile() {
      this.accordionHeaders.forEach((header, index) => {
        header.setAttribute('aria-expanded', String(index === this.openIndex));
      });

      this.tabPanels.forEach((panel, index) => {
        const isOpen = index === this.openIndex;
        panel.classList.toggle('active', isOpen);
        panel.setAttribute('aria-hidden', String(!isOpen));
      });
    }
  }

  customElements.define('m-product-details-tabs', ProductDetailsTabs);
}
